import React, { useEffect, useState } from 'react';
import Modal from '../../components/components/modal/modal.jsx';
import { ReactComponent as StarIcon } from '../../components/icons/star.svg';
import { ReactComponent as AngleDown } from '../../components/icons/angle-down.svg';

const defaultForm = {
    categoryId: '',
    organizerId: '',
    eventId: '',
    promotionType: '',
    startDate: '',
};

function PromoEventModal({ isOpen, onClose, onSubmit, initialData = null }) {
    const [formData, setFormData] = useState(defaultForm);

    useEffect(() => {
        if (initialData) {
            setFormData({
                categoryId: initialData.categoryId || '',
                organizerId: initialData.organizerId || '',
                eventId: initialData.eventId || '',
                promotionType: initialData.promotionType || '',
                startDate: initialData.startDate || '',
            });
        } else {
            setFormData(defaultForm);
        }
    }, [initialData, isOpen]);

    const handleChange = (field) => (e) => {
        setFormData((prev) => ({ ...prev, [field]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit) {
            onSubmit(formData);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} className="promo-modal-content">
            <div className="promo-modal-header">
                <StarIcon className="promo-modal-icon" />
                <h2>Promuj wydarzenie</h2>
            </div>

            <form className="promo-modal-form" onSubmit={handleSubmit}>
                <div className="promo-modal-row">
                    <label>Kategoria wydarzenia</label>
                    <div className="promo-modal-select">
                        <select value={formData.categoryId} onChange={handleChange('categoryId')}>
                            <option value="">Wybierz</option>
                            <option value="music">Muzyka</option>
                            <option value="sport">Sport</option>
                            <option value="culture">Kultura</option>
                        </select>
                        <AngleDown className="promo-modal-select-icon" />
                    </div>
                </div>

                <div className="promo-modal-row">
                    <label>Organizator</label>
                    <div className="promo-modal-select">
                        <select value={formData.organizerId} onChange={handleChange('organizerId')}>
                            <option value="">Wybierz</option>
                            <option value="fest">Festiwal'25</option>
                            <option value="masters">Event Masters</option>
                            <option value="urban">Urban Events</option>
                        </select>
                        <AngleDown className="promo-modal-select-icon" />
                    </div>
                </div>

                <div className="promo-modal-row">
                    <label>Wydarzenie</label>
                    <div className="promo-modal-select">
                        <select value={formData.eventId} onChange={handleChange('eventId')}>
                            <option value="">Wybierz</option>
                            <option value="fest25">Festiwal'25</option>
                            <option value="nasa">Konferencja NASA</option>
                            <option value="fale">Zawsze na fali</option>
                        </select>
                        <AngleDown className="promo-modal-select-icon" />
                    </div>
                </div>

                <div className="promo-modal-row">
                    <label>Rodzaj promowania</label>
                    <div className="promo-modal-select">
                        <select value={formData.promotionType} onChange={handleChange('promotionType')}>
                            <option value="">Wybierz</option>
                            <option value="Basic">Basic</option>
                            <option value="Standard">Standard</option>
                            <option value="Visibility+">Visibility+</option>
                            <option value="Premium">Premium</option>
                        </select>
                        <AngleDown className="promo-modal-select-icon" />
                    </div>
                </div>

                <div className="promo-modal-row">
                    <label>Data rozpoczęcia promowania</label>
                    <div className="promo-modal-date">
                        <input
                            type="date"
                            value={formData.startDate}
                            onChange={handleChange('startDate')}
                        />
                    </div>
                </div>

                <div className="promo-modal-actions">
                    <button type="button" className="promo-modal-cancel" onClick={onClose}>
                        Anuluj
                    </button>
                    <button type="submit" className="promo-modal-submit">
                        Promuj
                    </button>
                </div>
            </form>
        </Modal>
    );
}

export default PromoEventModal;
